import {message} from '@sail/intl';

export const navItemAriaLabel = message({
  id: 'mkt-ssr.testimonial_carousel.nav_item_aria_label',
  defaultMessage: 'Go to testimonial',
  description:
    'The Aria label for the nav item buttons. Explains what the button does.',
});
